// *******************
// *******************
// FILE AUTO GENERATO! n// *******************
// *******************

export const _permissionsDescriptionMap = {
  NotSet: "NotSet",
  Home: "Visualizza home",
  DispositiviRead: "Visualizza i propri dispositivi",
  DispositiviReadAll: "Visualizza tutti i dispositivi",
  DispositiviUpdateTrasferimenti: "Modifica i trasferimenti di un dispositivo",
  DispositivoCreate: "Crea un nuovo dispositivo",
  DispositivoUpdate: "Modificare un nuovo dispositivo",
  DispositivoGeneraCertificato:
    "Genera un nuovo certificato per la connessione al broker MQTT",
  DispositivoDelete: "Elimina un dispositivo",
  DispositiviReadManutenzioni: "Leggi le manutenzioni di un dispositivo",
  DispositiviUpdateManutenzioni: "Modifica le manutenzioni di un dispositivo",
  DispositivoRegistriRead: "Visualizza i registri di un dispositivo",
  DispositivoRegistriWrite: "Modifica i registri di un dispositivo",
  DispositiviDatiStoriciRead:
    "Visualizza i dati storici dei propri dispositivi",
  DispositiviDatiStoriciReadAll:
    "Visualizza i dati storici di tutti i dispositivi",
  DispositiviAlertValuesEdit: "Modifica dei valori min/max per gli alert",
  DispositiviAlertInternalUserOptionsEdit:
    "Modifica delle impostazioni per gli utenti interni (es: Invio email al tecnico Gatti)",
  DispositiviUpdateReminders: "Modifica i reminder di un dispositivo",
  AziendeReadAll: "Visualizza i dati di tutte le aziende",
  AziendeRead: "Visualizza i dati delle proprie aziende",
  AziendaRead: "Visualizza i dati della propria azienda",
  AziendaCreate: "Crea una azienda",
  AziendaUpdate: "Aggiorna un'azienda",
  AziendaEdit: "Modifica una azienda",
  AziendaDelete: "Elimina una azienda",
  ContenitoriRead: "Visualizza le proprie centrali",
  ContenitoriReadAll: "Visualizza i dati di tutte le centrali",
  ContenitoreCreate: "Crea una centrale",
  ContenitoreUpdate: "Modifica una centrale",
  ContenitoreUpdateAlloggiamentiFiltro:
    "Modifica gli alloggimenti filtro di una centrale",
  ContenitoreUpdateStoricoFiltri: "Modifica lo storico filtri di una centrale",
  ContenitoreUpdateStoricoOlio: "Modifica lo storico olio di una centrale",
  ContenitoreUpdateReminders: "Modifica i reminder di una centrale",
  ContenitoreUpdateBonifica:
    "Modifica lo storico delle bonifiche di una centrale",
  ContenitoreUpdateAnalisi: "Modifica le storico delle analisi di una centrale",
  ContenitoreUpdateFiltrazioni:
    "Modifica lo storico delle filtrazioni di una centrale",
  ContenitoreUpdateImmagini: "Modifica le immagini delle filtrazioni",
  ContenitoreDelete: "Elimina una centrale",
  GatewayRead: "Visualizza i propri Gateway",
  GatewayReadAll: "Visualizza i dati di tutti i Gateway",
  GatewayCreate: "Crea un gateway",
  GatewayUpdate: "Modifica un gateway",
  GatewayDelete: "Elimina un gateway",
  RipetitoreRead: "Visualizza i propri Ripetitori",
  RipetitoreReadAll: "Visualizza i dati di tutti i Ripetitori",
  RipetitoreCreate: "Crea un ripetitore",
  RipetitoreUpdate: "Modifica un ripetitore",
  RipetitoreDelete: "Elimina un ripetitore",
  GrafoRead: "Visualizza la struttura a grafo di tutti i portali",
  GrafoUpdate: "Modifica la struttura a grafo di tutti i portali",
  TrasferimentiChange: "Modificare i trasferimenti di un dispositivo",
  ConnessioneGatewayChange:
    "Modificare le connessioni di un dispositivo/ripetitore ad un gateway",
  UsersInterniRead: "Visualizzare gli utenti (interni)",
  UsersEsterniRead: "Visualizzare i clienti (account aziendali)",
  UsersInterniChange: "Modificare gli utenti (interni)",
  UsersEsterniChange: "Modificare i clienti (account aziendali)",
  ModelliFiltroChange: "Modificare i modelli di filtro",
  ModelliOlioChange: "Modificare i modelli di olio",
  ModelliGatewayChange: "Modificare i modelli gateway",
  DescrizioniBonificaChange: "Modificare le descrizioni di bonifica",
  DescrizioniManutenzioneChange: "Modificare le descrizioni di manutenzione",
  ModelliDispositivoChange:
    "Creare, modificare e eliminare modelli dispositivo",
  NodoIconeChange: "Modificare le icone dei nodi contenitore",
  FileUpload: "Caricare file",
  AnalisiListaReadAll: "Visualizza tutte le analisi",
  AnalisiListaRead: "Visualizza le analisi di questo utente",
  FiltrazioniListaReadAll: "Visualizza tutte le filtrazioni",
  FiltrazioniListaRead: "Visualizza le filtrazioni di questo utente",
  BonificheListaReadAll: "Visualizza tutte le Bonifiche",
  BonificheListaRead: "Visualizza le bonifiche di questo utente",
  CalendarioInterventiRead:
    "Visualizza il calendario con le analisi, filtraizoni e bonifiche",
  CalendarioTrasferimentiRead:
    "Visualizza il calendario con i trasferimenti dei dispositivi",
  RuoliPermessiRead: "Visualizza i permessi associati ai ruoli",
  RuoliPermessiUpdate: "Modifica l'associazione tra ruoli e permessi",
  RichiestePreventivoRead: "Visualizza le proprie richieste preventivo",
  RichiestePreventivoReadAll:
    "Visualizza tutte le richieste preventivo e filtra per commerciale",
  RichiestePreventivoUpdate: "Modifica le richieste preventivo",
  RichiestePreventivoDelete: "Elimina le richieste preventivo",
} as const;
